import builder from '../builder';
import ArrowRight1 from '../../streamline-icons/light/arrow-right-1.svg';

export default builder('IconArrowRight1Light', ArrowRight1);
